module.exports = "<div class=grid-x> <div class=\"cell medium-1 large-3\"></div> <div class=\"cell medium-10 large-6\"> <guest-edit></guest-edit> </div> <div class=\"cell medium-1 large-3\"></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/guest/views/guest.page.html
// module id = 713
// module chunks = 0